module.exports = __webpack_public_path__ + "static/media/icon_calendar.c28b7f6f.svg";